"use client";
import { motion } from "motion/react";
import { Icon } from "@iconify/react";

export default function CorporateBio() {
  return (
    <section className="py-24 px-6 max-w-[83.75rem] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        <span className="text-primary font-bold tracking-widest text-sm uppercase mb-4 block">
          Who We Are
        </span>
        <h2 className="text-40 md:text-50 font-bold mb-8 leading-tight text-midnight_text dark:text-white">
          Innovation Meets <br />
          <span className="text-primary">Safety Standards</span>
        </h2>

        {/* FULL TEXT CONTENT PRESERVED HERE */}
        <div className="space-y-6 text-lg text-muted leading-relaxed">
          <p>
            <strong className="text-midnight_text dark:text-white">
              CWD Digital Platforms
            </strong>{" "}
            specializes in the design and manufacturing of high-performance
            communication devices. We are a leading system integrator and
            automation partner for major organizations across domains such as
            Ex/IS-certified wireless telephony and radio communication, water
            network automation (DMA’s), photometric water analysis,
            instrumentation, and explosion-proof automation for fire and gas
            industries. Our services support a broad range of sectors including
            oil refineries, pharmaceuticals, chemical engineering, and public
            safety.
          </p>

          <p>
            As a prominent player in wireless communication and navigation
            systems, we have successfully established robust networks for
            numerous industries and police departments across India. We also
            serve as a key automation partner for water utilities, Indian
            Railways, and municipal corporations across Maharashtra and Madhya
            Pradesh.
          </p>

          <p>
            <strong className="text-midnight_text dark:text-white">
              Mobility for Hazardous Areas:
            </strong>{" "}
            In an increasingly safety-conscious environment, it is essential for
            employers to ensure worker protection in hazardous zones where
            explosive atmospheres may be present. Our solutions help mitigate
            the risk of equipment becoming an ignition source, enabling safe and
            reliable operations even in the most demanding industrial
            conditions.
          </p>
        </div>

        <div className="mt-10 p-8 bg-hero dark:bg-white/5 rounded-2xl border-l-4 border-primary relative">
          <Icon
            icon="ion:quote"
            className="absolute top-4 right-4 text-primary/20 text-4xl"
          />
          <p className="text-midnight_text dark:text-white font-medium italic text-lg relative z-10">
            "Safety, Performance, Reliability, and Product Documentation are our
            basic principles of product quality."
          </p>
        </div>
      </motion.div>

      {/* Abstract Visual - Glass Card Effect */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        className="relative h-[600px] w-full"
      >
        {/* Layered Cards for Depth */}
        <div className="absolute top-10 right-10 w-3/4 h-3/4 bg-primary rounded-3xl opacity-10 rotate-6"></div>
        <div className="absolute top-0 right-0 w-full h-full bg-white dark:bg-dark_b rounded-3xl border border-border dark:border-white/10 shadow-2xl overflow-hidden flex flex-col items-center justify-center p-12">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white dark:from-white/5 dark:to-transparent opacity-50"></div>

          <div className="relative z-10 w-48 h-48 bg-hero dark:bg-white/5 rounded-full flex items-center justify-center mb-8 ring-4 ring-primary/10 animate-pulse-slow">
            <Icon
              icon="ion:finger-print-outline"
              className="text-primary w-24 h-24"
            />
          </div>

          <div className="relative z-10 text-center">
            <h3 className="text-3xl font-bold text-midnight_text dark:text-white mb-2">
              Valuing People
            </h3>
            <div className="w-12 h-1 bg-primary mx-auto mb-2 rounded-full"></div>
            <p className="text-muted text-lg uppercase tracking-widest">
              People Valuing CWD
            </p>
          </div>

          {/* Decorative Corner Icons */}
          <Icon
            icon="ion:wifi"
            className="absolute top-8 left-8 text-border dark:text-white/5 text-6xl"
          />
          <Icon
            icon="ion:shield-checkmark"
            className="absolute bottom-8 right-8 text-border dark:text-white/5 text-6xl"
          />
        </div>
      </motion.div>
    </section>
  );
}
